<template>
  <div class="sfd-list-container">
    <!-- Affichage des données -->
    <div>
      <div
        v-for="(item, index) in sfdList"
        :key="index"
        class="w-full flex items-center text-black text-c14 2xl:text-c16 font-c4 text-left mb-6 diviser py-2 px-3 rounded-t-14 border-gray border-b"
      >
        <!-- Colonne 1 : Nom SFD + icône -->
        <div class="w-4/5 flex items-center gap-3 font-c5 text-c18">
          <icon
            :data="icons.propro"
            height="44"
            width="44"
            class="w-5 h-5"
            original
          />
          {{ item.sfd.name }}
        </div>
        
        <!-- Colonne 2 : Nombre de commerces -->
        <div class="w-1/4 ml-4 font-c4 text-c18">
          {{ item.totalCommerce }}
        </div>

        <!-- Actions -->
        <div class="w-1/6 Email responsive-large flex justify-center">
          <div class="flex items-center gap-3">
            <icon
              :data="icons.icedit"
              height="40"
              width="40"
              class="cursor-pointer"
              original
              @click="openModifsPrograms(item.sfd)"
            />
            <icon
              :data="icons.ic_delete"
              height="40"
              width="40"
              class="cursor-pointer"
              original
              @click="openDelete(item.sfd)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Popup suppression -->
  <deleteProgramsPopup
    v-if="deleteService"
    @closeDelete="closeDelete"
    @serviceDeactivated="handleServiceDeactivated"
    :service-id="oneService.id"
    :is-loading="isLoading"
    @refresh="refresh"
  />

  <!-- Popup modification -->
  <modifsProgramsPopup
    v-if="modifsService"
    :selected-service="selectedService"
    @closeCreate="closeCreate"
    :is-loading="isLoading"
    :service-id="oneService.id"
    @refresh="refresh"
  />
</template>

<script>
import IconFececamBenin from '../../../assets/icons/ic-fececamBenin.svg'
import IconPrograms from '../../../assets/icons/ic_programs.svg'
import apiroutes from '../../../router/api-routes'
import http from '../../../plugins/https'
import propro from "../../../assets/icons/propro.svg"
import icedit from "@/assets/icons/icedit.svg"
import ic_delete from "@/assets/icons/ic_delete.svg"
import deleteProgramsPopup from './deleteProgramsPopup.vue'
import modifsProgramsPopup from './modifsProgramsPopup.vue'

export default {
  name: "SfdList",
  components: { deleteProgramsPopup, modifsProgramsPopup },

  data() {
    return {
      icons: { IconFececamBenin, IconPrograms, propro, icedit, ic_delete },
      sfdList: null,
      deleteService: false,
      modifsService: false,
      isLoading: false,
      selectedService: null,
      oneService: {} // utilisé pour supprimer ou modifier
    }
  },

  created() {
    this.getData()
  },

  methods: {
    async getData() {
      try {
        const response = await http.get(apiroutes.baseURL + apiroutes.allSfd)
        this.sfdList = response
      } catch (error) {
        console.error(error)
      }
    },

    openModifsPrograms(service) {
      this.selectedService = { ...service }
      this.oneService = { ...service }
      this.modifsService = true
    },

    openDelete(service) {
      this.oneService = { ...service }
      this.deleteService = true
    },

    closeCreate(updated) {
      if (updated) {
        this.isLoading = true
        setTimeout(() => {
          this.isLoading = false
        }, 500)
      }
      this.modifsService = false
    },

    closeDelete() {
      this.deleteService = false
    },

    refresh() {
      this.getData()
    }
  }
}
</script>

<style scoped>
.sfd-list-container {
  width: 100%;
}
</style>
